//****************
// Lottie Animation //
//****************
import * as lottie from 'lottie-web/build/player/lottie.js';
import { lottieAnimationObsv } from './intersectionObservers';
import { eventThrottle } from '../../../utility';
import { HousesChartAniConfig, ChartAniConfig, RocketsAniConfig, HousesAniConfig } from './animations/animationConfigs.js';

export default initAnimations;

function initAnimations() {
  // Load the Houses Chart (the first animation visible on the page) first.
  // When it has finished downloading, begin downloading the next one.
  loadAnimation(HousesChartAniConfig, loadResettableAnimations, true);
}

/**
 * Function Declarations
 */

/**
 * Loads and keeps track of multiple Lottie animations.
 * These animations will be reset when the visitor
 * scrolls to the top of the page.
 * @return {void}
 */
function loadResettableAnimations() {
  // Keep track of which of the following animations get loaded.
  // We use this down below to reset animations when
  // the visitor scrolls to the top of the page.
  const loadedAnimations = [];

  loadedAnimations.push(loadAnimation(HousesAniConfig));
  loadedAnimations.push(loadAnimation(ChartAniConfig));
  loadedAnimations.push(loadAnimation(RocketsAniConfig));

  // Create an event listener to reset playback when the user scrolls
  // to the top of the page.
  window.addEventListener('scroll',
    eventThrottle(() => resetAnimations(loadedAnimations), 1000));
}

/**
 * Resets Lottie animations to the beginning and stops playback.
 * @param  {Array} animations Array of Lottie animations
 */
function resetAnimations(animations) {
  // eslint-disable-next-line compat/compat
  if ((window.scrollY || window.pageYOffset) < 200) {
    animations.forEach(ani => ani.goToAndStop(0));
  }
}

/**
 * Loads a Lottie animation using a configuration object.
 * @param  {animationConfig} animationConfig Object containing the URL and renderer information for a Lottie Animation
 * @return {LottieAnimation}                 A Lottie animation object. (playback can be controlled with this obj)
 */
function loadAnimation(animationConfig, dataReadyCallback, fadeIn) {
  // Load House Grid Animation
  // Check to see if the container exists
  if (animationConfig.container) {
    const lottieAnimation = lottie.loadAnimation(animationConfig);

    if (fadeIn) {
      Object.assign(animationConfig.container.style, {
        opacity: '0',
        transition: 'opacity 250ms ease 250ms',
      });

      lottieAnimation.addEventListener('data_ready', () => {
        lottieAnimation.stop();
        setTimeout(() => {
          window.getComputedStyle(animationConfig.container);
          Object.assign(animationConfig.container.style, {
            opacity: '1',
          });

          setTimeout(() => {
            lottieAnimation.play();
          }, 250);

        }, 250);
      });
    }

    lottieAnimationObsv(lottieAnimation).observe(animationConfig.container);

    if (dataReadyCallback) {
      lottieAnimation.addEventListener('data_ready', () => {
        dataReadyCallback();
      });
    }

    return lottieAnimation;
  }
}
